import { Injectable } from '@angular/core';

@Injectable()
export class RandomIdService {
  constructor() {
  }

  getRandomId(prefix: string = 'rxnt-'): string {
    // Victor: prefix with a letter to ensure valid id, otherwise can start with a number
    const randomStringLength = 9;
    const randomString = Math.random().toString(36).substring(2, 2 +
      randomStringLength).padStart(randomStringLength, '0');
    return prefix + randomString;
  }
}
